import { ResponseIdFormat } from './ResponseIdFormat';
export default ResponseIdFormat;
